// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    webserver: 'https://nst-caballus.uat.riafox.dev',
    GOOGLE_MAPS_API_KEY: 'AIzaSyDtn-m5KdS9dJQ2aw6fWFG0ONsUG4s_494',
    ionBaseUrl: 'http://localhost:9000',
    ionHorseProfileUrl: 'https://aa53bb3c51ba.ngrok-free.app/',
    jwplayer: {
        key: 'bmGApSGv',
        secret: 'P49NO3CLXlBshzgnyPYiJ3Aa',
        apiSecret: 'y7d0sulDEfqSg7AQH5yKeWInVEZKemJqVnljMU5DV1RKbE5uQkZaRmd5U25STWJGTm0n'
    },
    branchKey: 'key_test_hk8L87WzC69tHMNsb94XrjkfuzdPdkFX'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
